import { render } from "./k3.vue?vue&type=template&id=44eaf07e&scoped=true"
import script from "./k3.vue?vue&type=script&lang=js"
export * from "./k3.vue?vue&type=script&lang=js"

import "./k3.vue?vue&type=style&index=0&id=44eaf07e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44eaf07e"]])

export default __exports__